<ngx-spinner
    name="managementSpinner"
    color="#fff"
    size="medium"
    type="ball-clip-rotate-multiple">
    <p style="font-size: 20px; color: white">Creating Skin...</p></ngx-spinner>

<div
    class="sm:absolute pt-2 px-6 sm:inset-0 flex flex-col flex-auto min-w-0 sm:overflow-hidden bg-card dark:bg-transparent">

    <!-- Header -->
    <div
        class="relative flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between py-8 px-6 md:px-8 border-b">
        <!-- Title -->
        <div
            class="w-2/3 lg:4/5 text-4xl font-extrabold tracking-tight">Manage Roles
        </div>
        <!-- Actions -->
        <div class="flex shrink-0 items-center sm:mt-0 sm:ml-4">
            <!-- Search by Keyword -->
            <mat-form-field class="fuse-mat-dense fuse-mat-no-subscript fuse-mat-rounded min-w-64 pr-1"
                            *ngIf="!displayAddSkin"
                            [subscriptSizing]="'dynamic'">
                <mat-icon
                    class="icon-size-5"
                    matPrefix
                    [svgIcon]="'heroicons_solid:magnifying-glass'"></mat-icon>
                <input
                    matInput
                    (keyup)="onKeyup()"
                    [formControl]="inputSearchControl"
                    [autocomplete]="'off'"
                    [placeholder]="'Search for keyword'">
            </mat-form-field>
            <!-- Add Destination button -->
<!--            <button-->
<!--                *ngIf="!displayAddSkin"-->
<!--                class="ml-4"-->
<!--                mat-stroked-button-->
<!--                [color]="'primary'"-->
<!--                (click)="toggleAddSkin()">-->
<!--                <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>-->
<!--                <span class="ml-2 mr-1">Add</span>-->
<!--            </button>-->
        </div>
    </div>

    <!-- Main -->
    <div class="flex flex-auto overflow-hidden">

        <!-- Products list -->
        <div class="flex flex-col flex-auto sm:mb-18 overflow-hidden sm:overflow-y-auto" *ngIf="!displayAddSkin">
            <div class="grid">
                <!-- Header -->
                <div
                    class="story-types-grid z-10 sticky top-0 grid gap-4 py-4 px-6 md:px-8 shadow text-md font-semibold text-secondary bg-gray-50 dark:bg-black">
                    <div class="mt-2">ID</div> <!-- Second -->
                    <div
                        class="hidden sm:block mt-2"> <!-- Third -->
                        Name
                    </div>
                    <div class="hidden lg:block mt-2">Details</div> <!-- Fifth -->
                </div>
                <!-- Rows -->
                <ng-container *ngIf="tableElementsArray.length > 0; else noProducts">
                    <ng-container *ngFor="let elementTable of tableElementsArray">
                        <div class="story-types-grid grid items-center gap-4 py-3 px-6 md:px-8 border-b">

                            <!-- SKU -->
                            <div class="truncate"> <!-- Second -->
                                {{ elementTable.id_airline }}
                            </div>

                            <!-- Name -->
                            <div class="hidden sm:block truncate"> <!-- Third -->
                                {{ elementTable.ds_airline }}
                            </div>

                            <!-- Details button -->
                            <div class="flex items-center"> <!-- Seventh -->
                                <!--                                            class="min-w-10 min-h-7 h-7 px-2 leading-6"-->
                                <button
                                    class="relative flex flex-0 items-center justify-center w-12 h-12 mr-6 overflow-hidden"
                                    mat-stroked-button
                                    (click)="toggleDetails(elementTable.id_airline, 'id_airline')">
                                    <mat-icon
                                        class="icon-size-5"
                                        [svgIcon]="selectedElement?.id_airline === elementTable.id_airline ? 'heroicons_solid:chevron-up' : 'heroicons_solid:chevron-down'"></mat-icon>
                                </button>
                            </div>
                        </div>
                        <div class="grid"> <!-- First -->
                            <ng-container
                                *ngIf="selectedElement?.id_airline === elementTable.id_airline">
                                <ng-container
                                    *ngTemplateOutlet="rowDetailsTemplate; context: {$implicit: elementTable}"></ng-container>
                            </ng-container>
                        </div>
                    </ng-container>
                </ng-container>

                <ng-template #noProducts>
                    <div class="p-8 sm:p-16 border-t text-4xl font-semibold tracking-tight text-center">
                        <!--                        {{-->
                        <!--                            loadingMessage-->
                        <!--                        }}-->
                        <ngx-spinner
                            bdColor="rgba(51,51,51,0)"
                            color="#fff"
                            size="medium"
                            type="ball-clip-rotate-multiple">
                            <p style="font-size: 20px; color: white">Loading...</p></ngx-spinner>
                    </div>
                </ng-template>
            </div>

            <mat-paginator
                class="sm:absolute sm:inset-x-0 sm:bottom-0 border-b sm:border-t sm:border-b-0 z-10 bg-gray-50 dark:bg-transparent"
                (page)="searchElements('paginator')"
                [length]="20"
                [pageIndex]="0"
                [pageSize]="20"
                [pageSizeOptions]="[5, 10, 20, 100]"
                [showFirstLastButtons]="true"></mat-paginator>


            <ng-template #rowDetailsTemplate>
                <div class="shadow-lg overflow-hidden">
                    <div class="flex border-b">
                        <!-- Selected product form -->
                        <form
                            class="flex flex-col w-full"
                            [formGroup]="selectedStoryTypeForm">

                            <div class="flex flex-col sm:flex-row p-8">

                                <div class="flex flex-auto flex-wrap">
                                    <!-- Name, SKU & etc. -->
                                    <div class="flex flex-col w-full lg:w-2/4 sm:pl-8">

                                        <!-- Name -->

                                        <div class="flex">
                                            <mat-form-field class="w-full">
                                                <mat-label>Name</mat-label>
                                                <input
                                                    matInput
                                                    [formControlName]="'ds_name'">
                                            </mat-form-field>
                                        </div>

                                        <!-- Name -->

                                        <div class="flex">
                                            <mat-form-field class="w-full">
                                                <mat-label>ID</mat-label>
                                                <input
                                                    matInput
                                                    [formControlName]="'eleKey'">
                                            </mat-form-field>
                                        </div>

                                        <!-- Name -->

                                        <div class="flex flex-col gap-2 md:flex-row md:items-center mb-4">
                                            <mat-form-field class="flex-grow" floatLabel="always">
                                                <mat-label class="flex">
                                                    <p>Search</p>
                                                    <mat-icon svgIcon="heroicons_outline:exclamation-circle"
                                                              class="pb-1"
                                                              matTooltip="Search for a destination to add."></mat-icon>
                                                </mat-label>
                                                <input type="text"
                                                       placeholder="Destination"
                                                       aria-label="Destination"
                                                       (blur)="onBlur()"
                                                       (keyup)="onKeyupAutoSearch($event)"
                                                       matInput [formControl]="parentControl"
                                                       [matAutocomplete]="auto">
                                                <mat-autocomplete
                                                    requireSelection="true"
                                                    (optionSelected)="optionSelected($event)"
                                                    #auto="matAutocomplete"
                                                    [displayWith]="displayFn"
                                                    autoActiveFirstOption="true">
                                                    <mat-option *ngFor="let city of filteredParents | async"
                                                                [value]="city">
                                                        {{ city.ds_name }}
                                                    </mat-option>
                                                </mat-autocomplete>
                                                <mat-error
                                                    *ngIf="parentCheckerRequired && parentControl.invalid && (parentControl.touched || parentControl.dirty)">
                                                    Please select a valid destination.
                                                </mat-error>
                                            </mat-form-field>

                                            <button
                                                (click)="(!parentControl.value || parentControl.invalid) ? $event.preventDefault() : addToMapList()"
                                                mat-mini-fab
                                                class="shrink-0 w-32"
                                                [color]="'primary'"
                                                [ngClass]="{'opacity-50 pointer-events-none': !parentControl.value || parentControl.invalid}"
                                            >
                                                <span class="ml-2 mr-1">Add</span>
                                                <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                                            </button>
                                        </div>

                                    </div>


                                    <!-- Name, SKU & etc. -->
                                    <div class="flex flex-col w-full lg:w-2/4 sm:pl-8">


                                        <!-- Tags -->
                                        <span
                                            class="mb-px font-medium leading-tight"
                                        >Selected Destinations</span
                                        >
                                        <div
                                            class="mt-1.5 overflow-hidden rounded-md border border-gray-300 shadow-sm dark:border-gray-500"
                                        >
                                            <!-- Header -->
                                            <div
                                                class="-my-px flex items-center px-3 py-2"
                                            >
                                                <div
                                                    class="flex min-w-0 flex-auto items-center"
                                                >
                                                    <mat-icon
                                                        class="icon-size-5"
                                                        [svgIcon]="'heroicons_solid:magnifying-glass'"
                                                    ></mat-icon>
                                                    <input
                                                        class="ml-2 min-w-0 border-0 py-1"
                                                        type="text"
                                                        placeholder="Search"
                                                        [formControl]="inputInternalSearchControl"
                                                        [autocomplete]="'off'"
                                                        (keyup)="searchMapList()"
                                                        [maxLength]="50"
                                                    />
                                                </div>
                                            </div>
                                            <!-- Available tags -->
                                            <div
                                                class="h-48 overflow-y-auto border-t border-gray-300 leading-none dark:border-gray-500"
                                            >
                                                <!-- Tags editing -->
                                                <div class="space-y-2 p-4">
                                                    <ng-container *ngFor="let mapElement of filteredMapList">
                                                        <mat-form-field
                                                            class="fuse-mat-dense w-full"
                                                            [subscriptSizing]="'dynamic'"
                                                        >
                                                            <input
                                                                readonly
                                                                matInput
                                                                [value]="mapElement.ds_destinationchild"
                                                            />
                                                            <button
                                                                mat-icon-button
                                                                (click)="deleteTag(mapElement.id_destinationdependency, 'id_destinationdependency')"
                                                                matSuffix
                                                            >
                                                                <mat-icon
                                                                    class="icon-size-5"
                                                                    [svgIcon]="'heroicons_solid:trash'"
                                                                ></mat-icon>
                                                            </button>
                                                        </mat-form-field>
                                                    </ng-container>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>

                        </form>
                    </div>
                </div>
            </ng-template>

        </div>


        <div class="flex justify-center items-center w-full px-4 mb-20" *ngIf="displayAddSkin"
             [@zoomIn]="displayAddSkin">
            <div class="flex flex-col flex-auto w-full max-w-xl">
                <fuse-card
                    class="mt-8 p-6 pb-10 sm:p-10 sm:pb-7 rounded-2xl bg-card"
                    [flippable]="true"
                    [face]="'front'">
                    <ng-container fuseCardFront>
                        <!--Alert-->
                        <fuse-alert
                            class="mb-8"
                            *ngIf="alert"
                            [type]="alert.type"
                            [showIcon]="false">
                            {{ alert.message }}
                        </fuse-alert>
                        <form
                            class="space-y-3"
                            (ngSubmit)="createDestination()"
                            [formGroup]="newDestinationForm">
                            <div class="mb-6">
                                <div class="text-2xl font-bold tracking-tight">Add New Skin
                                </div>
                            </div>
                            <!-- Name -->
                            <mat-form-field class="w-full">
                                <input
                                    formControlName="ds_name"
                                    placeholder="New Skin Name"
                                    matInput
                                    maxlength="14"
                                    (input)="onInputMaxReach($event, 15)"
                                    [required]="true">
                                <mat-label>New Skin Name</mat-label>
                                <mat-error *ngIf="false">
                                    Required
                                </mat-error>
                            </mat-form-field>
                            <!-- Name -->

                            <!-- Name -->
                            <mat-form-field class="w-full">
                                <input
                                    noSpacesNoSpecial
                                    placeholder="New Skin Endpoint"
                                    formControlName="ds_url"
                                    matInput
                                    maxlength="14"
                                    (input)="onInputMaxReach($event, 15)"
                                    [required]="true">
                                <mat-label>New Skin Endpoint</mat-label>
                                <mat-error *ngIf="false">
                                    Required
                                </mat-error>
                            </mat-form-field>
                            <!-- Name -->

                            <mat-form-field class="w-full">
                                <mat-label>Original Skin to Copy</mat-label>
                                <input type="text"
                                       placeholder="Original Skin to Copy"
                                       aria-label="Original Skin to Copy"
                                       (blur)="onBlur()"
                                       (keyup)="keyUpAddSkin($event)"
                                       matInput [formControl]="parentControl"
                                       [matAutocomplete]="auto">
                                <mat-autocomplete
                                    (optionSelected)="optionSelected($event)"
                                    #auto="matAutocomplete"
                                    [displayWith]="displayFnSkin"
                                    autoActiveFirstOption="true">
                                    <mat-option *ngFor="let parent of filteredParents | async" [value]="parent">
                                        {{ parent.ds_airline }}
                                    </mat-option>
                                </mat-autocomplete>
                                <mat-error
                                    *ngIf="parentControl.invalid && (parentControl.touched || parentControl.dirty)">
                                    Please select a valid Skin.
                                </mat-error>
                            </mat-form-field>


                            <!-- Actions -->
                            <div class="flex items-center justify-end pb-4">
                                <button
                                    class="text-red-600"
                                    mat-stroked-button
                                    (click)="toggleAddSkin()"
                                    [color]="'accent'">
                                    Cancel
                                </button>
                                <button
                                    [disabled]="!newDestinationForm.valid || !selectedMapElement"
                                    class="ml-2"
                                    type="submit"
                                    mat-stroked-button
                                    [color]="'primary'">
                                    Submit
                                </button>
                            </div>
                        </form>
                    </ng-container>

                </fuse-card>
            </div>
        </div>

    </div>

</div>
